(function () {
  function initialiseGallery(root) {
    if (!root || root.dataset.aboutGalleryInitialised === 'true') return;

    var viewport = root.querySelector('[data-gallery-viewport]');
    var slides = Array.prototype.slice.call(
      root.querySelectorAll('.about-gallery__slide')
    );
    if (!viewport || !slides.length) return;

    root.dataset.aboutGalleryInitialised = 'true';
    var previousButton = root.querySelector('[data-gallery-prev]');
    var nextButton = root.querySelector('[data-gallery-next]');

    function slidePosition(slide) {
      var position = slide.offsetLeft - (viewport.clientWidth - slide.offsetWidth) / 2;
      var maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      return Math.max(0, Math.min(maximum, position));
    }

    function closestSlideIndex() {
      var viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
      var closestIndex = 0;
      var closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var distance = Math.abs(slideCenter - viewportCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function goToSlide(index, behaviour) {
      var boundedIndex = Math.max(0, Math.min(slides.length - 1, index));
      viewport.scrollTo({
        left: slidePosition(slides[boundedIndex]),
        behavior: behaviour || 'smooth'
      });
    }

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        goToSlide(closestSlideIndex() - 1);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goToSlide(closestSlideIndex() + 1);
      });
    }

    requestAnimationFrame(function () {
      goToSlide(Math.min(1, slides.length - 1), 'auto');
    });
  }

  function initialiseAll(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(
      container.querySelectorAll('.about-gallery'),
      initialiseGallery
    );
    if (container.matches && container.matches('.about-gallery')) {
      initialiseGallery(container);
    }
  }

  if (!window.BonoirAboutGallerySlider) {
    window.BonoirAboutGallerySlider = { initialiseAll: initialiseAll };
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll(document);
    });
    document.addEventListener('shopify:section:load', function (event) {
      initialiseAll(event.target);
    });
  }

  window.BonoirAboutGallerySlider.initialiseAll(document);
})();
